import * as React from 'react';

// TODO: move this to @gandi/redux-billing'
import { jsx as _jsx } from "react/jsx-runtime";
export default function PaymentPlaceholder({
  payment
}) {
  const formRef = React.useRef(null);
  React.useEffect(() => {
    if (payment && formRef.current !== null) {
      formRef.current.submit();
    }
  }, [payment]);
  if (!payment) {
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @gandi/gandi/no-global-element
    _jsx("form", {
      // $FlowFixMe[incompatible-type]
      ref: formRef,
      method: payment.method,
      action: payment.url || '/billing/payment-return',
      children: Object.keys(payment.params).map(key => /*#__PURE__*/_jsx("input", {
        type: "hidden",
        name: key,
        value: payment.params[key]
      }, key))
    })
  );
}